/**
 * Derive a darker, solid background Tailwind class for a flag swatch dot from
 * the stored `color` string (which is shaped like "bg-red-100 text-red-800 border-red-300").
 * Returns a `bg-*-500` class so the dot is clearly visible against the dropdown
 * background. Falls back to `bg-maroon-600` if the color string is unparseable.
 */
export function swatchBg(color) {
    if (!color)
        return "bg-maroon-600";
    const m = color.match(/bg-([a-z]+)-100/);
    if (m)
        return `bg-${m[1]}-500`;
    // Admin purple / legacy purple
    if (color.includes("purple"))
        return "bg-purple-500";
    return "bg-maroon-600";
}
//# sourceMappingURL=flags.js.map